import React from 'react';
import { WizardStep } from './WizardStep';
import './Wizard.scss';
export var WizardStatus;
(function (WizardStatus) {
    WizardStatus[WizardStatus["NotStarted"] = 0] = "NotStarted";
    WizardStatus[WizardStatus["InProgress"] = 1] = "InProgress";
    WizardStatus[WizardStatus["Pending"] = 2] = "Pending";
    WizardStatus[WizardStatus["Completed"] = 3] = "Completed";
    WizardStatus[WizardStatus["Error"] = 4] = "Error";
})(WizardStatus || (WizardStatus = {}));
export const Wizard = ({ className, items }) => {
    return (React.createElement("div", { className: `wizard text-center ${className}` }, items.map((item, idx) => React.createElement(WizardStep, { key: idx, id: idx, item: item }))));
};
//# sourceMappingURL=Wizard.js.map